import ContentListPage from "./ContentListPage";

function RealWeddingsListPage() {
  return (
    <ContentListPage
      contentType="real_wedding"
      title="Real Weddings"
      addLabel="Add Real Wedding"
      addPath="/admin/add-real-wedding"
      editPathPrefix="/admin/add-real-wedding"
      emptyText="No real weddings yet. Click Add Real Wedding to create one."
      searchPlaceholder="Search by heading or description..."
    />
  );
}

export default RealWeddingsListPage;
